var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.625 7.4375L13.3125 9.125L10.3828 12.0547C10.3125 12.125 10.2422 12.1484 10.1719 12.1719L8.48438 12.5C8.34375 12.5469 8.20312 12.4062 8.25 12.2656L8.57812 10.5781C8.60156 10.5078 8.625 10.4375 8.69531 10.3672L11.625 7.4375ZM14.7422 6.5L14.25 6.00781C13.9219 5.67969 13.3828 5.67969 13.0547 6.00781L12.1641 6.89844L13.8516 8.58594L14.7422 7.69531C15.0703 7.36719 15.0703 6.82812 14.7422 6.5ZM8.4375 12.5H8.46094C8.4375 12.5234 8.41406 12.5 8.39062 12.5C8.41406 12.5 8.4375 12.5 8.4375 12.5ZM2.25 3.5C2.25 1.85938 3.58594 0.5 5.22656 0.5C6.84375 0.5 8.22656 1.85938 8.22656 3.5C8.22656 5.16406 6.86719 6.5 5.22656 6.5C3.5625 6.5 2.25 5.16406 2.25 3.5ZM3.375 3.5C3.375 4.55469 4.19531 5.375 5.25 5.375C6.28125 5.375 7.125 4.55469 7.125 3.5C7.125 2.46875 6.28125 1.625 5.25 1.625C4.19531 1.625 3.375 2.46875 3.375 3.5ZM7.64062 11.375H1.14844C1.3125 9.89844 2.57812 8.75 4.125 8.75H6.375C7.14844 8.75 7.875 9.07812 8.41406 9.59375L9.21094 8.79688C8.48438 8.07031 7.47656 7.625 6.375 7.625H4.125C1.82812 7.625 0 9.47656 0 11.75C0 12.1719 0.328125 12.5 0.75 12.5H7.52344C7.47656 12.3828 7.47656 12.2422 7.5 12.1016L7.64062 11.375Z",
    fill: "#1D2132",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserPen);
export default __webpack_public_path__ + "static/media/user-pen.a0f4149f1e9aa4add1decf767ad89419.svg";
export { ForwardRef as ReactComponent };